@if (modulesToBuild && modulesToBuild.length > 0 && !isUiTest) {
    <div class="module-dynamic-header" style="float: right;">
        <button class='btn-medium-secondary' (click)="openFullScreenDialog()">Manage Dashboard</button>
    </div>
    <div style="clear:both; height: 5px;"></div>

    <div class="module-dynamic-builder">
        @for (module of modulesToBuild; track module.id) {
            @if (module.enabled) {
                <div class="dynamic-module" [class.module-single-view]="module.singleWidth" [class.module-double-view]="!module.singleWidth">
                    <ng-container [ngComponentOutlet]="module.type" [ngComponentOutletInputs]="{singleWidth: module.singleWidth, globalSettings: globalSettings, customizableMode: false}"></ng-container>
                </div>
            }
        }
    </div>
}
